<ng-container *ngFor="let field of formFields">
	<cv-form-field
		*ngIf="showFormFields"
		[options]="{
			label: field.label,
			path: field.path
		}">

	</cv-form-field>
</ng-container>

<div class="inline-flex">
	<button pButton label="Cancel" icon="pi pi-times" class="p-button-text p-button-secondary"
			(click)="close()"></button>
	<button pButton label="Save" icon="pi pi-check" class="p-button-text" (click)="addNewItem()"></button>
</div>
